import 'react-toastify/dist/ReactToastify.css';
import './custom-bootstrap-colors.scss';
import { QueryClient, QueryClientProvider } from 'react-query';
import AppRoutes from './app-routes';
import { GlobalStyle } from './globalStyles';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { theme } from './theme';

const queryClient = new QueryClient();

function App() {
  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <AppRoutes />
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
